module.exports = __webpack_public_path__ + "static/font-awesome_4-6-3_trash_64_8_000000_none.png";